import { LIVE_CLASS_TRANSLATION_KEYS, PcRevampType } from '../../../shared/types/live-class-locked-state-keys';
import { LiveClassDto } from '../../../shared/types/LiveClassDto';
import { LiveClassTileInputData } from '../../../shared/types/LiveClassTileInputData';
import { ClassTileStates } from '../../../shared/types/LiveClassTileStates';

declare var window: any;

export class ClassTile {
  public pcRevampType: PcRevampType;
  private _currentState: ClassTileStates = 'NONE';

  public lockedTextKey: string;
  public signUpInProgress = false;
  public liveClass: LiveClassDto;

  constructor(pcRevampType: PcRevampType, liveClass: LiveClassDto) {
    this.pcRevampType = pcRevampType;
    this.liveClass = liveClass;
  }

  public destroy() {}

  public get currentState(): ClassTileStates {
    return this._currentState;
  }
  public set currentState(value: ClassTileStates) {
    this.liveClass.tileState = value;
    this._currentState = value;
  }
  public get tileData(): LiveClassTileInputData {
    return LIVE_CLASS_TRANSLATION_KEYS[this.currentState]
      ? LIVE_CLASS_TRANSLATION_KEYS[this.currentState][this.pcRevampType]
      : {};
  }

  private get translationKey() {
    return LIVE_CLASS_TRANSLATION_KEYS[this.currentState][this.pcRevampType];
  }

  public get stateTextKey(): string {
    return this.translationKey ? this.translationKey.stateTextKey : '';
  }

  public get buttonCaption(): string {
    const classType = this.liveClass.classType;
    if (!this.translationKey) return '';
    if (this.currentState === 'HAS_JOIN') {
      return this.translationKey.buttonCaption[classType];
    }
    return this.translationKey.buttonCaption;
  }

  public get title(): string {
    return this.liveClass.title;
  }

  public get description(): string {
    return this.liveClass.description;
  }

  public get buttonDisabled(): boolean {
    return this.currentState === 'SIGNUP_CONFIRM' && this.signUpInProgress;
  }

  public onShowDocumentClick(event: PointerEvent): void {
    event.stopPropagation();
    window.open(this.liveClass.documentLink);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/class-tile/class-tile.ts